import React from "react"
import PropTypes from "prop-types"
import { Flex, Select } from "antd"
import { useTranslation } from "react-i18next"
import MultiSelect from "components/common/MultiSelect"
import FilterChips from "ui/FilterChips"
import styles from "./index.module.css"

const LIST_FOR_OPTIONS = [
  { value: "assign_equipment", labelKey: "booking.equipment.list_for.assign_equipment" },
  { value: "all_equipment", labelKey: "booking.equipment.list_for.all_equipment" }
]

const EquipmentFilters = ({ selectedCategories, onCategoryChange, categoryOptions = [], selectedListFor, onListForChange }) => {
  const { t } = useTranslation()

  const listForOptions = LIST_FOR_OPTIONS.map(({ value, labelKey }) => ({
    value,
    label: t(labelKey)
  }))

  return (
    <Flex vertical gap={12}>
      <Flex gap={12} wrap="wrap">
        <Select value={selectedListFor} onChange={onListForChange} options={listForOptions} style={{ minWidth: "200px" }} />
        <MultiSelect
          value={selectedCategories}
          onChange={onCategoryChange}
          options={categoryOptions}
          placeholder={t("booking.equipment.category_filter")}
          dropdownClassName={styles.categoryDropdown}
          t={t}
          style={{ minWidth: "200px", maxWidth: "240px" }}
        />
      </Flex>
      <FilterChips selectedValues={selectedCategories} options={categoryOptions} onChange={onCategoryChange} />
    </Flex>
  )
}

EquipmentFilters.propTypes = {
  selectedCategories: PropTypes.arrayOf(PropTypes.string).isRequired,
  onCategoryChange: PropTypes.func.isRequired,
  categoryOptions: PropTypes.arrayOf(
    PropTypes.shape({
      value: PropTypes.string.isRequired,
      label: PropTypes.string.isRequired
    })
  ).isRequired,
  selectedListFor: PropTypes.string.isRequired,
  onListForChange: PropTypes.func.isRequired
}

export default EquipmentFilters
